<template>
  <div>
    <b-card>
      <div slot="header" v-if="!add && lock">
        Pattern Detail ({{ model.id }})
        <span class="float-right ml-1 mr-1"> ( edit : {{ model.updated_at | sdate }} ) </span>
        <span class="float-right ml-1 mr-1"> {{ model.created_at | sdate }} </span>
      </div>
      <div slot="header" v-if="!add && !lock">
        Modify Pattern ({{ model.id }})
        <span class="float-right ml-1 mr-1"> ( edit : {{ model.updated_at | sdate }} ) </span>
        <span class="float-right ml-1 mr-1"> {{ model.created_at | sdate }} </span>
      </div>
      <div slot="header" v-if="add && !lock">
        Create Pattern
      </div>

      <b-row>
        <b-col md="3">
          <b-form-group class="text-primary" label="Status" label-for="ph_is_use">
            <c-switch color="info" label size="lg" id="ph_is_use" v-model="model.is_alive" :disabled="lock" />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group class="text-primary" label="Direct" label-for="ph_is_direct">
            <c-switch color="info" label size="lg" id="ph_is_direct" v-model="model.is_direct" :disabled="lock" />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group class="text-primary" label="Publish" label-for="ph_is_publish">
            <c-switch color="info" label size="lg" id="ph_is_publish" v-model="model.is_publish" :disabled="lock || origin_status == true" />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group class="">
            <label class="text-primary">Source(Broker)</label>
            <b-input type="text" v-model="model.origin" :plaintext="lock" rows="1"></b-input>
            (
              <span v-if="model.broker">
                {{ model.broker }}
              </span>
              <span v-else>
                -
              </span>
            )
          </b-form-group>
        </b-col>

      </b-row>

      <b-row class="mt-2">
        <b-col md="3">
          <b-form-group class="">
            <label class="d-block text-primary">WEBCastle</label>
            <i v-if="model.is_webcastle" class="fa fa-check text-success" style="font-size: 1.2rem; width: 10%;"></i>
            <span v-else>
              N/A
            </span>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group class="">
            <label class="d-block text-primary">WSFinder</label>
            <i v-if="model.is_wsfinder" class="fa fa-check text-success" style="font-size: 1.2rem; width: 10%;"></i>
            <span v-else>
              N/A
            </span>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group>
            <label class="text-primary d-block">WMDS</label>
            <i v-if="model.is_wmds" class="fa fa-check text-success" style="font-size: 1.2rem; width: 10%;"></i>
            <span v-else>
              N/A
            </span>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group class="">
            <label class="d-block text-primary">Frequency</label>
            {{ model.hit }}
          </b-form-group>
        </b-col>

      </b-row>

      <b-row class="mt-2">
        <b-col md="3">
          <b-form-group class="">
            <label class="d-block text-primary">Binary</label>
            <i v-if="model.is_binary" class="fa fa-check text-success" style="font-size: 1.2rem; width: 10%;"></i>
            <span v-else>
              N/A
            </span>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group class="">
            <label class="d-block text-primary">Excutable</label>
            <i v-if="model.is_excute" class="fa fa-check text-success" style="font-size: 1.2rem; width: 10%;"></i>
            <span v-else>
              N/A
            </span>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group>
            <label class="text-primary d-block">Webshell</label>
            <i v-if="model.is_webshell" class="fa fa-check text-success" style="font-size: 1.2rem; width: 10%;"></i>
            <span v-else>
              N/A
            </span>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group class="">
            <label class="d-block text-primary">TLP</label>
            {{ model.tlp }}
          </b-form-group>
        </b-col>

      </b-row>

      <hr>
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group class="text-primary">
                <label>Level</label>
                <v-select v-model="model.level" :options="codes.level" :disabled="lock"></v-select>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group class="text-primary">
                <label>Type</label>
                <v-select v-model="model.type" :options="codes.policy" :disabled="lock"></v-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group class="text-primary">
                <label class="d-block">Expire_at</label>
                <date-picker :disabled="lock" class="mt-2 mr-2 w-100" v-model="model.expire_at" style="width: 140px" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group class="text-primary">
                <!-- <label class="d-block">issue_date</label>
                <date-picker v-if="model.issue_date" :disabled="lock" class="mt-2 mr-2 w-100" v-model="model.issue_date" style="width: 140px" :confirm="false" :first-day-of-week="1"></date-picker> -->
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group class="text-primary">
                <label>
                  Code
                  <span v-if="model.code" class="ml-2" style="cursor:pointer;" v-clipboard:copy="model.code"
                    v-clipboard:success="() => $toastr.s('copied')" v-clipboard:error="() => $toastr.s('copy failed')">
                    <i class="fa fa-copy" style="font-size:18px;color:gray"></i>
                  </span>
                </label>
                <b-textarea type="text" style="background-color:#f0f3f5;" v-model="model.code" :plaintext="lock"
                  rows="1"></b-textarea>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="">
            <b-col>
              <b-form-group class="text-primary">
                <label>
                  Code hash(MD5)
                  <span v-if="model.code_hash" class="ml-2 link" style="cursor:pointer;"
                    v-clipboard:copy="model.code_hash" v-clipboard:success="() => $toastr.s('copied')"
                    v-clipboard:error="() => $toastr.s('copy failed')">
                    <i class="fa fa-copy d-inline-block" style="font-size:18px;color:gray"></i>
                  </span>
                </label>
                <b-textarea type="text" style="background-color:#f0f3f5;" v-model="model.code_hash" :plaintext="lock"
                  rows="1"></b-textarea>
              </b-form-group>

            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group class="text-primary">
                <label>
                  UUID
                  <span v-if="model.uuid" class="ml-2" style="cursor:pointer;" v-clipboard:copy="model.uuid"
                    v-clipboard:success="() => $toastr.s('copied')" v-clipboard:error="() => $toastr.s('copy failed')">
                    <i class="fa fa-copy" style="font-size:18px;color:gray"></i>
                  </span>
                </label>
                <b-textarea type="text" style="background-color:#f0f3f5;" v-model="model.uuid" :plaintext="lock"
                  rows="1"></b-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <hr>

      <b-row>
        <b-col>
          <b-tabs>
            <b-tab>
              <template #title>
                Relationship
                <b-badge class="ml-2" variant="primary" v-if="from_target_list.length">
                  + {{ from_target_list.length }}
                </b-badge>
              </template>
              <table class="table">
                <thead>
                  <th style="width: 20%;">
                    Issued_date
                  </th>
                  <th style="width: 20%;">
                    Type
                  </th>
                  <th style="width: auto;">
                    Code
                  </th>
                  <th style="width: 10%;">
                    Frequency
                  </th>
                </thead>
                <tbody>
                  <!-- from -->
                  <tr v-if="!model.bridges || from_target_list.length < 1">
                    <td colspan="4" class="text-center">
                      no data
                    </td>
                  </tr>
                  <tr v-for="(item, index) in from_target_list" :key="index">
                    <td>
                      <span v-if="item.from">
                        {{ item.from.issue_date | datetime2 }}
                      </span>
                      <span v-else-if="item.target">
                        {{ item.target.issue_date | datetime2 }}
                      </span>
                      <span v-else>
                        N/A
                      </span>

                    </td>
                    <td>
                      <span v-if="item.from">
                        <div
                          v-if="item.from && item.from.code"
                          class="d-inline text-primary"
                          style="cursor:pointer; width: 80px"
                          v-clipboard:copy="item.from.code"
                          v-clipboard:success="() => $toastr.s('copied')"
                          v-clipboard:error="() => $toastr.s('copy failed')"
                        >
                          <i class="fa fa-copy" style="font-size:18px;color:gray"></i>
                          {{ item.from.type }}
                        </div>
                      </span>
                      <span v-else-if="item.target">
                        <div
                          v-if="item.target && item.target.code"
                          class="d-inline text-primary"
                          style="cursor:pointer; width: 80px"
                          v-clipboard:copy="item.target.code"
                          v-clipboard:success="() => $toastr.s('copied')"
                          v-clipboard:error="() => $toastr.s('copy failed')"
                        >
                          <i class="fa fa-copy" style="font-size:18px;color:gray"></i>
                          {{ item.target.type }}
                        </div>
                      </span>
                      <span v-else>
                        N/A
                      </span>

                    </td>
                    <td>

                      <div v-if="item.from">
                        <i class="fa fa-search d-inline text-primary"></i>
                        <Data class="d-inline ml-2" :data="item.from.code" :isFunction="true" @click="move(item.from.id)" :dataLength="45" />
                      </div>
                      <div v-else-if="item.target">
                        <i class="fa fa-search d-inline text-primary"></i>
                        <Data class="d-inline ml-2" :data="item.target.code" :isFunction="true" @click="move(item.target.id)" :dataLength="45" />
                      </div>
                      <span v-else>
                        N/A
                      </span>
                    </td>
                    <td>
                      <span v-if="item.from">
                        {{ item.from.hit }}
                      </span>
                      <span v-else-if="item.target">
                        {{ item.target.hit }}
                      </span>
                      <span v-else>
                        N/A
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab :disabled="!file_list">
              <template #title>
                File
                <b-badge class="ml-2" variant="danger" v-if="file_list.length">
                  + {{ file_list.length }}
                </b-badge>
              </template>
              <table class="table">
                <thead>
                  <th style="width: 15%;">
                    Issued_date
                  </th>
                  <th style="width: 20%; min-width: 200px;">
                    File Hash
                  </th>
                  <th style="width: 10%;">
                    Frequency
                  </th>
                </thead>
                <tbody>
                  <!-- from -->
                  <tr v-if="!model.bridges || file_list.length < 1">
                    <td colspan="4" class="text-center">
                      no data
                    </td>
                  </tr>
                  <tr v-for="(item, index) in file_list" :key="index">
                    <td>
                      <span v-if="item.file">
                        {{ item.file.created_at | datetime2 }}
                      </span>
                      <span v-else>
                        N/A
                      </span>

                    </td>
                    <td>

                      <a v-if="item.file" href="javascript:void(0);" @click="move(item.file.id)">
                        <i class="fa fa-search text-primary d-inline" aria-hidden="true"></i> {{ item.file.file_hash }}
                      </a>
                      <div v-if="item.file && item.file.file_hash" class="d-inline" style="cursor:pointer; width: 80px" v-clipboard:copy="item.file.file_hash"
                        v-clipboard:success="() => $toastr.s('copied')" v-clipboard:error="() => $toastr.s('copy failed')">
                        <i class="fa fa-copy" style="font-size:18px;color:gray"></i>
                      </div>
                      <span v-if="!item.file">
                        N/A
                      </span>
                    </td>
                    <td>
                      <span v-if="item.file">
                        {{ item.file.hit }}
                      </span>
                      <span v-else>
                        N/A
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>

      <hr>

      <b-button size="sm" variant="light" @click="back"> Back </b-button>
      <template v-if="lock">
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="primary" @click="edit"> Modify </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true"> Delete </b-button>
        </div>
      </template>
      <template v-else>
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="danger" @click="cancel"> Cancel </b-button>
          <b-button size="sm" variant="primary" @click="save"> Save </b-button>
        </div>
      </template>
    </b-card>
    <b-modal title="Confirm - Delete user account" class="modal-danger" v-model="confirm" @ok="remove"
      ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { api, auth } from '@/f1/service';
import codes from '@/f1/codes';
// import reg from '@/f1/reg'
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/f1/custom';
import 'vue2-datepicker/index.css';
import 'vue-select/dist/vue-select.css';
import Data from '@/f1/views/components/data';
import _ from 'lodash';

const default_model = () => ({
  origin: '',
  is_direct: false,
  issue_date: '',

  is_wsfinder: false,
  is_wmds: false,
  is_webcastle: false,

  level: 'MEDIUM',
  type: codes.policy[0],
  code: '',
  code_hash: '',
  country: '',

  is_binary: false,
  is_excute: false,
  extension: '',

  hit: 0,
  tlp: '',

  summary: '',
  analysis_date: '',
  analysis: '',

});

export default {
  components: { cSwitch, vSelect, DatePicker, moment, Data },
  data: () => ({
    origin_status :  false,
    datepicker,
    codes,
    api,
    confirm: false,
    add: false,
    lock: true,
    model: default_model(),
    profile: auth.profile,
    is_downloading: false,
    LEVEL: [

    ]
  }),
  computed: {
    from_target_list() { return _.filter(this.model.bridges, x => x.from || x.target) },
    file_list() { return _.uniqBy(_.filter(this.model.bridges, x => x.file), x => x.file.id) },
  },
  methods: {
    move(id) {
      if(confirm('move to page ?')) {
        this.$router.push({ name: 'uwss_pattern', params: { id: id } })
        this.$emit('refresh')
      }
    },
    async download() {

      if (!this.model.file_id) {
        return this.$toastr.w("no available doiwnload content")
      }

      if (this.is_downloading) {
        return this.$toastr.w("already downloading")
      }
      this.is_downloading = true
      let rv = await api.uwss.pattern.download(this.model.file_id)
      const byteCharacters = atob(rv); // base64 문자열을 디코딩하여 바이너리 데이터로 변환
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const link = document.createElement('a');
      link.href = URL.createObjectURL(new Blob([new Uint8Array(byteNumbers)], { type: 'application/octet-stream' }));
      link.download = `${this.model.file_hash}.f1`;
      link.click(); // 다운로드 링크 클릭

      this.is_downloading = false;
      return
    },
    cancel() { this.$router.replace({ name: 'uwss_pattern', params: { id: this.model.id } }); },
    edit() { this.$router.replace({ name: 'uwss_pattern', params: { id: this.model.id, tag: 'edit' } }); },
    async remove() {
      try {
        await api.uwss.pattern.delete(this.model.id);
        this.$emit('refresh'); this.$toastr.s('pattern deleted.'); this.list();
      } catch (e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.$router.go(-1); },
    list() { this.$router.push({ name: 'uwss_pattern' }); },
    // regex_valid: (c, f = '') => {
    //   if(!c) { return false }
    //   try { new RegExp(c, f); return true } catch(e) { return false }
    // },
    async save() {
      try {
        if (!(this.model.code || '').trim()) { return this.$toastr.e('code required.'); }
        if (!(this.model.level || '').trim()) { return this.$toastr.e('level required.'); }

        if (this.model.id) {
          await api.uwss.pattern.update(this.model);
        }
        else {
          this.model.id = +(await api.uwss.pattern.add(this.model));
        }
        this.$toastr.s('Done.'); this.$emit('refresh'); this.cancel();
      } catch (e) { this.$toastr.e(e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] pattern.detail', 'load item', id);

      if (id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      try {
        this.model = Object.assign({}, this.model, await api.uwss.pattern.get(id));

        this.model.issue_date = moment(this.model.issue_date).toDate();
        this.model.expire_at = moment(this.model.expire_at).toDate();

        this.origin_status = this.model.is_publish;
      }
      catch (e) { console.log(e); this.$toastr.e(e.data || e); this.list(); }
    }
  },
  watch: { '$route'(to, from) { this.get(to.params); console.log(from) } },
  created() { },
  destroyed() { },
  mounted() {
    this.get(this.$route.params);
  }
}
</script>
